import { Box, Skeleton, Typography } from '@mui/material'

import {
  COLOR_LAST_BID,
  COLOR_LAST_COMPLETED_JOB,
} from 'components/reports/Metrics/constants/SupplierActivityRecency'

interface Props {
  caption: string
  bid?: number | null
  job?: number | null
  loading?: boolean
}

export const MeanDailyValuesEndpoint = ({ caption, bid, job, loading }: Props) => (
  <Box textAlign='right'>
    <Typography variant='caption' color='text.secondary' display='block'>
      {caption}
    </Typography>
    {loading ? (
      <Skeleton width={70} />
    ) : (
      <>
        <Typography variant='subtitle1' fontWeight={700} sx={{ color: COLOR_LAST_BID }}>
          {bid == null ? '—' : `${bid} days`}
        </Typography>
        <Typography variant='subtitle1' fontWeight={700} sx={{ color: COLOR_LAST_COMPLETED_JOB }}>
          {job == null ? '—' : `${job} days`}
        </Typography>
      </>
    )}
  </Box>
)
